import React from 'react';
import './Styles/CenteredContainer.css';

/**
 * Component that horizontally centers its children in a centered container.
 * By default the children will take up 80% of the width of the parent.
 * Props can be passed to modify this behavior:
 * - ratio: will be used to set the width of the centered child wrapper.
 * Use this to change the default 80% width.
 * - maxWidth: by default there is no maximum, but can be set to limit its growth
 * @param {*} props
 */
export const CenteredContainer = props => {
  const contentStyles = {};
  contentStyles['width'] = props.ratio || '80%';
  if (props.maxWidth) {
    contentStyles['maxWidth'] = props.maxWidth;
  }

  return (
    <div className="CenteredContainer" style={props.style ? props.style : {}}>
      <div style={contentStyles}>{props.children}</div>
    </div>
  );
};
